import React, { useState, createContext, ReactNode, useContext, useEffect } from "react";
import { themes } from "../setup/theme/themes";
import * as Log from "src/util/SDayslogger";
import { env } from "../config/env";

interface GlobalContextType {
  theme: string;
  themeSwitchHandler: (themeType: string) => void;
}

const initialContext: GlobalContextType = {
  theme: "",
  themeSwitchHandler: () => {},
};

export const GlobalContext = createContext<GlobalContextType>(initialContext);

interface GlobalContextProviderProps {
  children: ReactNode;
}

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}: GlobalContextProviderProps) => {
  const [currentTheme, setCurrentTheme] = useState<string>("");

  const themeSwitchHandler = (themeType: string) => {
    setCurrentTheme(themeType);
  };

  function updateDocumentTitle(newTitle: string) {
    document.title = newTitle;
  }

  useEffect(() => {
    // Read the theme value from an environment variable (e.g., VITE_THEME)
    const themeFromEnv = env.THEME;

    //get url and domain
    // Extract the theme from the subdomain
    const currentURL = window.location.href;
    const domain = window.location.hostname
    const themeFromDomain = domain.split(".")[0];
    Log.debug(`theme.env ${themeFromEnv}, currentURL: ${currentURL}, domain: ${domain}, themeFromDomain ${themeFromDomain} `);

    if (themeFromEnv && themeFromEnv !== undefined && themeFromEnv !== "") {
      setCurrentTheme(themeFromEnv);
      const faviconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
      if (faviconLink && themes[themeFromEnv] && themes[themeFromEnv].urlLogo) {
        faviconLink.href = themes[themeFromEnv].urlLogo; 
      }
      if(themes[themeFromEnv] && themes[themeFromEnv].name){
        updateDocumentTitle(themes[themeFromEnv].name);
      }
    }else if(currentURL.toLowerCase().includes('smile-interactive.com')){
      Log.debug(`set theme smile cause smile-interactive.com`)
      setCurrentTheme('smile');
      const themeName = 'smile';
      const faviconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
      if (faviconLink && themes[themeName] && themes[themeName].urlLogo) {
        faviconLink.href = themes[themeName].urlLogo; 
      }
      if(themes[themeName] && themes[themeName].name){
        updateDocumentTitle(themes[themeName].name);
      }
    }else if(currentURL.toLowerCase().includes('7daysdesk.com')){
      Log.debug(`set theme sevendays cause 7daysdesk.com`)
      setCurrentTheme('sevendays');
    }else{
      Log.debug(`set theme sevendays cause default`)
      setCurrentTheme('sevendays');
    }
  }, []);


  return (
    <GlobalContext.Provider
      value={{
        theme: currentTheme,
        themeSwitchHandler: themeSwitchHandler,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
